import { ElMessageBox } from 'element-plus';

export default {
  mounted(el, binding) {
    const { callback, params } = binding.value;
    el.addEventListener('click', () => {
      ElMessageBox.confirm('すべてのデータを消去してもよろしいですか？', '', {
        closeOnClickModal: false,
      }).then(() => {
        callback(params.param1, params.param2);
      });
    });
  },
};
